import React from "react";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

function MyFileViewer({ type, file }) {
    const docs = [{ uri: file, fileType: type }];
    return (
        <Box
            sx={{
                width: "100%",
                height: "calc(100vh - 56px)",

                "& > div": {
                    height: "100%",

                    "& > div": {
                        overflowY: "hidden",
                    },
                },
            }}
        >
            <DocViewer
                pluginRenderers={DocViewerRenderers}
                documents={docs}
                config={{
                    header: {
                        disableHeader: true,
                        disableFileName: false,
                        retainURLParams: false,
                    },
                }}
            />
        </Box>
    );
}

export default MyFileViewer;
MyFileViewer.propTypes = {
    type: PropTypes.string.isRequired,
    file: PropTypes.string.isRequired,
};
